import React, { FC, Ref, createRef, useState } from 'react'
import Link from 'next/link'
import styles from './index.module.scss'
import { useTranslation } from 'next-i18next'
import { SafePlayVideo, SafeStopVideo } from '~/modules/Shared/Infrastructure/SafeVideoElement'
import { ComponentTrophyDto } from '~/modules/Products/Infrastructure/Dtos/ComponentTrophyDto'

interface Props {
  trophyDto: ComponentTrophyDto
  backlink?: boolean
}

export const MemoryAddableTrophyCard: FC<Props> = ({ trophyDto, backlink }) => {
  const { t } = useTranslation('trophies')
  const player: Ref<HTMLVideoElement> = createRef()
  const [playPromise, setPlayPromise] = useState<Promise<void>>(Promise.resolve())

  let media

  if (trophyDto.animation !== null) {
    media = (
      <video
        className={ styles.trophyCard__media }
        preload={ 'none' }
        poster={ trophyDto.imageUrl }
        loop={ true }
        autoPlay={ false }
        muted={ true }
        ref={ player }
      >
        <source
          src={ trophyDto.animation.url }
          type={ trophyDto.animation.type }
        />
      </video>
    )
  } else {
    media = (
      <img
        className={ styles.trophyCard__media }
        src={ trophyDto.imageUrl }
        alt={ trophyDto.description }
      />
    )
  }

  return (
    <div
      data-qa="trophy-card-container"
      className={ styles.trophyCard__container }
      onMouseOver={ async () => player.current ? await SafePlayVideo(player.current, setPlayPromise) : '' }
      onMouseLeave={ () => player.current ? SafeStopVideo(player.current, playPromise) : '' }
    >
      <Link
        href={ backlink ? `/trophies/${trophyDto.id}?backlink` : `/trophies/${trophyDto.id}` }
        className={ styles.trophyCard__link }
      >
        { t('show_info_button') }
      </Link>

      <div
        className={ styles.trophyCard__discipline }
      >
        { trophyDto.discipline }
      </div>

      <div
        data-qa="media-container"
        className={ styles.trophyCard__imageWrapper }>
        { media }
      </div>

      <div className={ styles.trophyCard__data }>
        <div className={ styles.trophyCard__competition }>
          { trophyDto.content.header }
        </div>
        <div className={ styles.trophyCard__fullName }>
          { trophyDto.content.title }
        </div>
        <div className={ styles.trophyCard__extra }>
          { trophyDto.content.subtitle }
        </div>
      </div>

      <div className={ styles.trophyCard__buttons }>
        <span></span>
        <Link
          className={ styles.trophyCard__memoriesButton }
          href={ `/trophies/${trophyDto.id}/memories` }
        >
          { t('add_memories_button') }
        </Link>
      </div>
    </div>
  )
}
